import { browserHistory } from 'react-router';

import {
    DRAWER,
    LOGIN_USER_SUCCESS,
    LOGIN_USER_FAILURE,
    LOGIN_USER_REQUEST,
    LOGOUT_USER,
    REGISTER_USER_FAILURE,
    REGISTER_USER_REQUEST,
    REGISTER_USER_SUCCESS,
} from '../constants/index';

import { AuthApi } from '../api/auth_api'
import { UserApi } from '../api/usersApi'
import { parseJSON } from '../utils/misc';


export function loginUserSuccess(data) {
    localStorage.setItem('access-token', data.access_token);
    localStorage.setItem('refresh-token', data.refresh_token);
    return {
        type: LOGIN_USER_SUCCESS,
        payload:{
            userId: data.id
        },

    };
}


export function loginUserFailure(error) {
    localStorage.removeItem('access-token');
    localStorage.removeItem('refresh-token');
    return {
        type: LOGIN_USER_FAILURE,
        payload: {
            status: error.response.status,
            statusText: error.response.statusText,
        },
    };
}

export function loginUserRequest() {
    return {
        type: LOGOUT_USER,
    };
}

export function relogin(){
    return {
        type: LOGOUT_USER,
    };
}
export function logoutAndRedirect() {
    return function (dispatch){
        dispatch(relogin());
        let token = localStorage.getItem('refresh-token')
        AuthApi.logout(token)
        .then((response)=>{
            localStorage.removeItem('access-token');
            localStorage.removeItem('refresh-token');
            browserHistory.push('/login');

        })
        .catch(error =>{
            browserHistory.push('/login');
        })
        
        return {
            type: LOGOUT_USER,
        };
    };
}

export function redirectToRoute(route) {
    return () => {
        browserHistory.push(route);
    };
}

export function loginUser(email, password) {
    return function (dispatch) {
        dispatch(loginUserRequest());
        return AuthApi.getToken(email, password)
            .then(response => {
                try {
                    dispatch(loginUserSuccess(response.data));
                    browserHistory.push('/main');
                } catch (e) {
                    dispatch(loginUserFailure({
                        response: {
                            status: error.status,
                            statusText: 'Invalid user or password',
                        },
                    }));
                }
            })
            .catch(error => {
                dispatch(loginUserFailure({
                    response: {
                        status: error.response.status,
                        statusText: error.response.data.user[0]
                    },
                }));
            });
        
    };
};


export function registerUserRequest() {
    return {
        type: REGISTER_USER_REQUEST,
    };
}

export function registerUserSuccess() {
    return {
        type: REGISTER_USER_SUCCESS,
    };
}

export function registerUserFailure(error) {
    localStorage.removeItem('access-token');
    localStorage.removeItem('refresh-token');
    return {
        type: REGISTER_USER_FAILURE,
        payload: {
            status: error.response.status,
            statusText: error.response.statusText,
        },
    };
}

export function registerUser(email, password, tin, phone, username) {
    return function (dispatch) {
        dispatch(registerUserRequest());
        return UserApi.createUser(email, password, tin, phone, username)
            .then(parseJSON)
            .then(() => {
                try {
                    dispatch(registerUserSuccess());
                    browserHistory.push('/main');
                } catch (e) {
                    dispatch(registerUserFailure({
                        response: {
                            status: 403,
                            statusText: 'Intente nuevamente',
                        },
                    }));
                }
            })
            .catch(error => {
                let text = 'Hubo un error, Intente nuevamente';
                if (error.response.status == 406){
                    text = 'El mail ya esta registrado'
                }
                else if(error.response.status == 422){
                    const validationErrorField = Object.keys(error.response.data)[0]
                    text =  error.response.data[validationErrorField][0]
                }
                dispatch(registerUserFailure({
                    response: {
                        status: 403,
                        statusText: text,
                    },
                }
                ));
            });
    };
}

export function switchMenu(data) {
    return {
        type: DRAWER,
        payload:{
            openMenu: data
        },

    };
}


// WEBPACK FOOTER //
// ./src/actions/auth.js